/**
 * @file AboutView.jsx
 * @author Daniel Aguirre
 * @description About View Page
 */

// Dependencies
import {
  AppstoreAddOutlined,
  FileDoneOutlined,
  SafetyOutlined
} from '@ant-design/icons';
import AppCardLayout from 'components/AppCardLayout';
import ListItem from 'components/ListItem';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Assets
import baxterLogo from '@nephro/assets/RenalCareServices_Cyan.png';

function AboutView() {
  const { t: translate } = useTranslation();
  const style = { fontSize: 29, color: 'var(--color-brand-navy)' };

  const version = (
    <h3 className={`mb-0 text-sm font-bold`}>{translate('about.version')}</h3>
  );
  const versionIcon = <AppstoreAddOutlined style={style} />;
  const versionOptions = <span className="text-placeholder">1.36.2</span>;

  const TermsAndConditions = (
    <h3 className={`mb-0 text-sm font-bold`}>
      {translate('about.termsAndConditions')}
    </h3>
  );
  const TermsAndConditionsIcon = <FileDoneOutlined style={style} />;

  const privacyPolicy = (
    <h3 className={`mb-0 text-sm font-bold`}>
      {translate('about.privacyPolicy')}
    </h3>
  );
  const privacyPolicyIcon = <SafetyOutlined style={style} />;

  return (
    <AppCardLayout>
      <div className="text-baxterGray p-4 h-full">
        <section className="h-4/5">
          <header>
            <h1 className="mb-4" style={{ fontSize: 22 }}>
              {translate('about.title')}
            </h1>
          </header>
          <section>
            <ListItem
              icon={versionIcon}
              body={version}
              options={versionOptions}
            />
            <ListItem
              icon={TermsAndConditionsIcon}
              body={TermsAndConditions}
              link={'/main/terms-and-conditions'}
            />
            <ListItem
              icon={privacyPolicyIcon}
              body={privacyPolicy}
              link={'/main/privacy'}
            />
            <p className="text-placeholder px-10 text-center mt-8">
              {translate('about.copyRight')}
            </p>
          </section>
        </section>
        <figure className="w-full h-1/5 m-0">
          <img src={baxterLogo} className="m-auto" />
        </figure>
      </div>
    </AppCardLayout>
  );
}

export default AboutView;
